import { render } from "./AutomationCard.vue?vue&type=template&id=4f34ee12&scoped=true"
import script from "./AutomationCard.vue?vue&type=script&lang=js"
export * from "./AutomationCard.vue?vue&type=script&lang=js"

import "./AutomationCard.vue?vue&type=style&index=0&id=4f34ee12&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f34ee12"]])

export default __exports__